import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { Web3 } from 'web3';
import { useLocation } from 'react-router-dom';
import { presetConfigurations, TOKEN_ADDRESSES } from './config';
import { useGlobalState } from '../GlobalStateContext';
import { 
  fetchTokenInfo, 
  fetchPoolInfo, 
} from './poolUtils';
import LiquidPoolInfo from './LiquidPoolInfo';
import WalletAddressTutorial from '../guide/WalletAddressTutorial';
let updated=false;


function SwapPage() {
  const { params, updateParams } = useGlobalState();
  if(!updated){
    updated=true;
    try{
 const presetIdD = localStorage.getItem('selectedPreset')||"ab" ;

 if (presetIdD) {
      const selectedConfig = presetConfigurations.find(config => config.id === presetIdD);
      if (selectedConfig) {
        // Update params with the selected configuration
        updateParams({
          contractAddress: selectedConfig.contractAddress,
          fromTokenAddress: selectedConfig.fromTokenAddress,
          toTokenAddress: selectedConfig.toTokenAddress,
          poolAddress: selectedConfig.poolAddress
        });
      }
    }

}catch(e){
  console.error(e)
}
 
  }
  const location = useLocation();
  const [status, setStatus] = useState('');
  const [isBeginnerMode, setIsBeginnerMode] = useState(() => {
    const saved = localStorage.getItem('isBeginnerMode');
    return saved !== null ? JSON.parse(saved) : true; // 默认为新手模式
  });
  const [selectedPreset, setSelectedPreset] = useState(() => {
    const saved = localStorage.getItem('selectedPreset') ;
    return saved || '';
  });
  
  // Add state for tutorial modal
  const [showTutorialModal, setShowTutorialModal] = useState(false);
  
  // CSS styles for modal and help button
  const styles = {
    modalOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    },
    modalContent: {
      backgroundColor: '#fff',
      padding: '20px',
      borderRadius: '8px',
      maxWidth: '800px',
      width: '90%',
      maxHeight: '90vh',
      overflow: 'auto',
      position: 'relative'
    },
    closeButton: {
      position: 'absolute',
      top: '10px',
      right: '15px',
      fontSize: '24px',
      fontWeight: 'bold',
      border: 'none',
      background: 'none',
      cursor: 'pointer'
    },
    helpButton: {
      marginLeft: '10px',
      padding: '2px 8px',
      fontSize: '12px',
      backgroundColor: '#4CAF50',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer'
    }
  };
  
  const [tokenInfo, setTokenInfo] = useState({
    fromToken: { name: '', symbol: '' },
    toToken: { name: '', symbol: '' }
  });
  
  const [poolInfo, setPoolInfo] = useState({
    token0: '',
    token1: '',
    token0Name: '',
    token1Name: '',
    fee: 0
  });
  
  
  
  const [historyOptions, setHistoryOptions] = useState({
    contractAddress: [],
    fromTokenAddress: [],
    toTokenAddress: [],
    poolAddress: [],
    sender: []
  });
  
  const [validationErrors, setValidationErrors] = useState({
    fromTokenAddress: false,
    toTokenAddress: false
  });


  // Web3 instance
  const web3 = useMemo(() => new Web3('https://bsc-dataseed.bnbchain.org'), []);
  
  // Load history options from localStorage on component mount
  useEffect(() => {
    const savedHistoryOptions = localStorage.getItem('swapHistoryOptions');
    if (savedHistoryOptions) {
      try {
        const parsed = JSON.parse(savedHistoryOptions);
        // 确保所有必要的字段都存在且是数组
        const completeOptions = {
          contractAddress: Array.isArray(parsed.contractAddress) ? parsed.contractAddress : [],
          fromTokenAddress: Array.isArray(parsed.fromTokenAddress) ? parsed.fromTokenAddress : [],
          toTokenAddress: Array.isArray(parsed.toTokenAddress) ? parsed.toTokenAddress : [],
          poolAddress: Array.isArray(parsed.poolAddress) ? parsed.poolAddress : [],
          sender: Array.isArray(parsed.sender) ? parsed.sender : []
        };
        setHistoryOptions(completeOptions);
      } catch (e) {
        console.error('Failed to parse saved history options', e);
        // 如果解析失败，使用默认的空数组结构
        setHistoryOptions({
          contractAddress: [],
          fromTokenAddress: [],
          toTokenAddress: [],
          poolAddress: [],
          sender: []
        });
      }
    }
  }, []);

  // Save history options to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem('swapHistoryOptions', JSON.stringify(historyOptions));
  }, [historyOptions]);

  // Save beginner mode preference to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('isBeginnerMode', JSON.stringify(isBeginnerMode));
  }, [isBeginnerMode]);

  // Save selected preset to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('selectedPreset', selectedPreset);
  }, [selectedPreset]);

  // Apply saved preset configuration on component mount
  useEffect(() => {
    const savedPreset = localStorage.getItem('selectedPreset');
    if (savedPreset && savedPreset !== '') {
      const selectedConfig = presetConfigurations.find(config => config.id === savedPreset);
      if (selectedConfig) {
        // Update params with the selected configuration
        updateParams({
          contractAddress: selectedConfig.contractAddress,
          fromTokenAddress: selectedConfig.fromTokenAddress,
          toTokenAddress: selectedConfig.toTokenAddress,
          poolAddress: selectedConfig.poolAddress
        });
        
        console.log('===== 自动应用保存的预设配置 =====');
        console.log('配置名称:', selectedConfig.name);
        console.log('代币地址:', selectedConfig.fromTokenAddress);
        console.log('稳定币地址:', selectedConfig.toTokenAddress);
        console.log('流动池地址:', selectedConfig.poolAddress);
        console.log('合约地址:', selectedConfig.contractAddress);
        console.log('====================');
      }
    }
  }, []); // Empty dependency array means this runs only once on mount

  // Function to add an item to history
  const addToHistory = (field, value, label) => {
    if (!value || value.trim() === '') return;
    
    setHistoryOptions(prev => {
      // 确保 prev[field] 存在且是数组，否则使用空数组
      const currentArray = Array.isArray(prev[field]) ? prev[field] : [];
      const exists = currentArray.some(item => item.value === value);
      
      if (exists) {
        return {
          ...prev,
          [field]: currentArray.map(item => 
            item.value === value ? { ...item, label } : item
          )
        };
      } else {
        return {
          ...prev,
          [field]: [{ value, label }, ...currentArray.slice(0, 19)]
        };
      }
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    // 如果是流动池地址字段且包含URL（可能是从dexscreener复制的链接）
    let processedValue = value;
    if (name === 'poolAddress' && value.includes('/')) {
      const parts = value.split('/');
      processedValue = parts[parts.length - 1];
      console.log(`从URL提取池地址: ${processedValue}`);
    }
    
    // Update the parameters state using global state
    updateParams({
      [name]: processedValue
    });
  };

  // Handle dropdown selection
  const handleDropdownChange = (e) => {
    const { name, value } = e.target;
    
    // Update the parameters state using global state
    updateParams({
      [name]: value
    });
  };

  // Handle preset selection
  const handlePresetChange = (e) => {
    const presetId = e.target.value;
    setSelectedPreset(presetId);
    
    if (presetId) {
      const selectedConfig = presetConfigurations.find(config => config.id === presetId);
      if (selectedConfig) {
        // Update params with the selected configuration
        updateParams({
          contractAddress: selectedConfig.contractAddress,
          fromTokenAddress: selectedConfig.fromTokenAddress,
          toTokenAddress: selectedConfig.toTokenAddress,
          poolAddress: selectedConfig.poolAddress
        });
        
        // Token information will be automatically fetched by the useEffect
        
        console.log('===== 应用预设配置 =====');
        console.log('配置名称:', selectedConfig.name);
        console.log('代币地址:', selectedConfig.fromTokenAddress);
        console.log('稳定币地址:', selectedConfig.toTokenAddress);
        console.log('流动池地址:', selectedConfig.poolAddress);
        console.log('合约地址:', selectedConfig.contractAddress);
        console.log('====================');
      }
    } else {
      // Clear token info when no preset is selected
      setTokenInfo({
        fromToken: { name: '', symbol: '' },
        toToken: { name: '', symbol: '' }
      });
    }
  };

  const getInputStyle = (fieldName) => {
    return {
      border: validationErrors[fieldName] ? '2px solid red' : '',
      backgroundColor: validationErrors[fieldName] ? '#fff0f0' : ''
    };
  };

  

  // Function to handle token info fetching with error handling
  const handleFetchTokenInfo = async (tokenAddress, tokenType) => {
    if (!tokenAddress || !web3.utils.isAddress(tokenAddress)) return;
    
    try {
      const result = await fetchTokenInfo(web3, tokenAddress, tokenType);
      if (result) {
        setTokenInfo(prev => ({
          ...prev,
          [tokenType]: result
        }));
        
        // Add to history with the fetched symbol
        addToHistory(`${tokenType}Address`, tokenAddress, result.symbol);
      }
    } catch (error) {
      console.error(`Error fetching ${tokenType} info:`, error);
    }
  };

  // Function to handle pool info fetching with error handling
  const handleFetchPoolInfo = async (poolAddress) => {
    try {
      const result = await fetchPoolInfo(web3, poolAddress);
      setPoolInfo(result);
      
      if (result.token0 && result.token1) {
        // Add to history with pool info
        addToHistory('poolAddress', poolAddress, `${result.token0Name}/${result.token1Name} (${result.fee/10000}%)`);
      }
    } catch (error) {
      console.error('Error fetching pool info:', error);
    }
  };



  // Effect to monitor token address changes and set up periodic refresh
  useEffect(() => {
    let intervalId = null;
    
    const refreshTokenInfo = () => {
      if (params.fromTokenAddress && web3.utils.isAddress(params.fromTokenAddress)) {
        handleFetchTokenInfo(params.fromTokenAddress, 'fromToken');
      }
      if (params.toTokenAddress && web3.utils.isAddress(params.toTokenAddress)) {
        handleFetchTokenInfo(params.toTokenAddress, 'toToken');
      }
    };
    
    // Initial fetch when addresses change
    refreshTokenInfo();
    
    // Set up interval to refresh every 10 seconds
    if (params.fromTokenAddress || params.toTokenAddress) {
      intervalId = setInterval(refreshTokenInfo, 10000);
      console.log('设置token信息定时刷新，每10秒检查一次');
    }
    
    // Cleanup interval on unmount or when addresses change
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
        console.log('清除token信息定时刷新');
      }
    };
  }, [params.fromTokenAddress, params.toTokenAddress]);

  // Effect to monitor pool address changes and set up periodic refresh
  useEffect(() => {
    let intervalId = null;
    
    const refreshPoolInfo = () => {
      if (params.poolAddress && web3.utils.isAddress(params.poolAddress)) {
        handleFetchPoolInfo(params.poolAddress);
      }
    };
    
    // Initial fetch when pool address changes
    refreshPoolInfo();
    
    // Set up interval to refresh every 10 seconds
    if (params.poolAddress) {
      intervalId = setInterval(refreshPoolInfo, 10000);
      console.log('设置池信息定时刷新，每10秒检查一次');
    }
    
    // Cleanup interval on unmount or when pool address changes
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
        console.log('清除池信息定时刷新');
      }
    };
  }, [params.poolAddress]);

  const renderAdvancedMode = () => {
    return (
      <div>
        <div className="input-container">
          <label htmlFor="contractAddress">刷分合约 <span className="required">*</span></label>
          <div className="dropdown-container" style={{ position: 'relative' }}>
            <input
              type="text"
              id="contractAddress"
              name="contractAddress"
              value={params.contractAddress}
              onChange={handleInputChange}
              className="address-input"
              list="contractAddressList"
              required
            />
            <datalist id="contractAddressList">
              {historyOptions.contractAddress.map((option, index) => (
                <option key={index} value={option.value} label={option.label} />
              ))}
            </datalist>
          </div>
        </div>
        
        <div className="input-container">
          <label htmlFor="fromTokenAddress">代币地址 <span className="required">*</span></label>
          <div className="dropdown-container" style={{ position: 'relative' }}>
            <input
              type="text"
              id="fromTokenAddress"
              name="fromTokenAddress"
              value={params.fromTokenAddress}
              onChange={handleInputChange}
              className="address-input"
              list="fromTokenList"
              required
              style={getInputStyle('fromTokenAddress')}
            />
            <datalist id="fromTokenList">
              {historyOptions.fromTokenAddress.map((option, index) => (
                <option key={index} value={option.value} label={option.label} />
              ))}
            </datalist>
          </div>
          {tokenInfo.fromToken.name && (
            <div className="token-info">
              {tokenInfo.fromToken.name} ({tokenInfo.fromToken.symbol})
            </div>
          )}
        </div>
        
        <div className="input-container">
          <label htmlFor="toTokenAddress">稳定币地址(如usdt usdc bnb usd1) <span className="required">*</span></label>
          <div className="dropdown-container" style={{ position: 'relative' }}>
            <input
              type="text"
              id="toTokenAddress"
              name="toTokenAddress"
              value={params.toTokenAddress}
              onChange={handleInputChange}
              className="address-input"
              list="toTokenList"
              required
              style={getInputStyle('toTokenAddress')}
            />
            <datalist id="toTokenList">
              {historyOptions.toTokenAddress.map((option, index) => (
                <option key={index} value={option.value} label={option.label} />
              ))}
            </datalist>
          </div>
          {tokenInfo.toToken.name && (
            <div className="token-info">
              {tokenInfo.toToken.name} ({tokenInfo.toToken.symbol})
            </div>
          )}
        </div>
        
        <div className="input-container">
          <label htmlFor="poolAddress">流动池地址 <span className="required">*</span> <a href="https://www.metlex.io/" target="_blank" rel="noopener noreferrer">(查询 选择dex按钮粘贴ca)</a></label>
          <div className="dropdown-container" style={{ position: 'relative' }}>
            <input
              type="text"
              id="poolAddress"
              name="poolAddress"
              value={params.poolAddress}
              onChange={handleInputChange}
              className="address-input"
              list="poolAddressList"
              required
            />
            <datalist id="poolAddressList">
              {historyOptions.poolAddress.map((option, index) => (
                <option key={index} value={option.value} label={option.label} />
              ))}
            </datalist>
          </div>
          {poolInfo.token0 && (
            <div className="pool-info">
              <div>Token0: {poolInfo.token0Name} ({poolInfo.token0})</div>
              <div>Token1: {poolInfo.token1Name} ({poolInfo.token1})</div>
              <div>Fee: {poolInfo.fee / 10000}% ({poolInfo.fee})</div>
            </div>
          )}
          <LiquidPoolInfo poolAddress={params.poolAddress} />
        </div>
      </div>
    );
  };

  // Function to handle opening and closing the tutorial modal
  const toggleTutorialModal = () => {
    setShowTutorialModal(!showTutorialModal);
  };

  // Modal component for the tutorial
  const TutorialModal = () => {
    if (!showTutorialModal) return null;
    
    return (
      <div style={styles.modalOverlay} onClick={toggleTutorialModal}>
        <div style={styles.modalContent} onClick={e => e.stopPropagation()}>
          <button style={styles.closeButton} onClick={toggleTutorialModal}>×</button>
          <h2>如何获取钱包地址</h2>
          <WalletAddressTutorial />
        </div>
      </div>
    );
  };

  return (
    <div className="SwapPage">
      <h1>刷分配置</h1>
      
      {/* Beginner Mode Toggle */}
      {location.pathname !== '/liquid' && (<div className="beginner-mode-toggle">
        <label className="toggle-switch">
          <input
            type="checkbox"
            checked={isBeginnerMode}
            onChange={(e) => setIsBeginnerMode(e.target.checked)}
          />
          <span className="toggle-slider"></span>
          <span className="toggle-label">新手模式</span>
        </label>
        <p className="toggle-description">
          {isBeginnerMode ? '已开启新手模式，隐藏高级选项' : '关闭新手模式，显示所有选项'}
        </p>
      </div>)}
      
      {/* 在 /liquid 路由下不显示币安钱包地址填写框 */}
      {location.pathname !== '/liquid' && (
        <div className="input-container">
          <label htmlFor="sender">
            你的币安钱包地址 <span className="required">*</span>
            <button 
              type="button" 
              style={styles.helpButton}
              onClick={toggleTutorialModal}
            >
              如何获取钱包地址?
            </button>
          </label>
          <div className="dropdown-container" style={{ position: 'relative' }}>
            <input
              type="text"
              id="sender"
              name="sender"
              value={params.sender}
              onChange={handleInputChange}
              className="address-input"
              list="senderList"
              required
            />
            <datalist id="senderList">
              {historyOptions.sender.map((option, index) => (
                <option key={index} value={option.value} label={option.label} />
              ))}
            </datalist>
          </div>
          <div style={{ marginTop: '3px' }}>
            <a 
              href={`https://www.bn-alpha.site/${params.sender}`} 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ color: '#4CAF50', textDecoration: 'underline', fontSize: '12px' }}
            >
              第三方网站: 查看今天已经刷了多少分( 利润不准 因为统计不到卖出)
            </a>
          </div>
        </div>
      )}
      
      {/* Render the tutorial modal */}
      <TutorialModal />
      
      {/* Preset Configuration Dropdown for Beginner Mode */}
      {isBeginnerMode && (
        <div className="input-container">
          <label htmlFor="presetConfig">选择刷分策略 <span className="required">*</span></label>
          <select
            id="presetConfig"
            value={selectedPreset}
            onChange={handlePresetChange}
            className="preset-dropdown"
            required
          >
            <option value="">请选择一个配置...</option>
            {presetConfigurations.map((config) => (
              <option key={config.id} value={config.id}>
                {config.name}
              </option>
            ))}
          </select>
          {selectedPreset && (
            <div className="preset-info">
              <p>已选择: {presetConfigurations.find(c => c.id === selectedPreset)?.name}</p>
              <p style={{ 
                color: 'white', 
                fontWeight: 'bold', 
                marginTop: '6px',
                marginBottom: '6px',
                padding: '6px',
                backgroundColor: '#333',
                borderRadius: '5px',
                border: '1px solid #555',
                fontSize: '11px'
              }}>
                {presetConfigurations.find(c => c.id === selectedPreset)?.desc}
              </p>
              {tokenInfo.fromToken.symbol && tokenInfo.toToken.symbol && (
                <p style={{ 
                  color: '#007bff', 
                  fontWeight: 'bold', 
                  marginTop: '6px',
                  marginBottom: '4px',
                  padding: '6px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '5px',
                  border: '1px solid #dee2e6',
                  fontSize: '11px',
                  lineHeight: '1.3'
                }}>
                  使用说明: 在币安web3钱包使用 {tokenInfo.toToken.symbol} 兑换 {tokenInfo.fromToken.symbol}
                  <br/>
                  {location.pathname !== '/liquid' && (
<span>在临近输入指纹/扫脸 确认买入交易时, 点击页面页面右侧的绿色卖按钮
当操作日志弹出"手机请买入代币!!!!" 时, 在手机上确认交易</span>
                  )}
                  
                </p>
              )}
              {/* Liquidity Information */}
              <LiquidPoolInfo poolAddress={params.poolAddress} />
            </div>
          )}
        </div>
      )}
    

     

      {!isBeginnerMode && renderAdvancedMode()}
     
      {status && <p className="StatusMessage">{status}</p>}
    </div>
  );
}

export default SwapPage; 